<div class="developers-wrapper">
    <app-site-nav></app-site-nav>

    <div class="docs-layout">
        <!-- Sidebar Navigation -->
        <aside class="docs-sidebar">
            <div class="sidebar-header">
                <div class="api-badge">
                    <svg viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="3" width="20" height="18" rx="3" stroke="currentColor" stroke-width="1.5" />
                        <path d="M7 8h4M7 12h10M7 16h6" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" />
                    </svg>
                    <span>LIAM API</span>
                </div>
                <span class="version-badge">v1.0</span>
            </div>

            <div class="sidebar-search">
                <svg viewBox="0 0 20 20" fill="none">
                    <circle cx="9" cy="9" r="6" stroke="currentColor" stroke-width="1.5" />
                    <path d="M14 14l4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <input type="text" placeholder="Search endpoints..." [(ngModel)]="searchQuery"
                    (input)="filterEndpoints()">
            </div>

            <nav class="sidebar-nav">
                <div class="nav-section">
                    <button class="nav-section-header" (click)="toggleSection('overview')"
                        [class.expanded]="expandedSections['overview']">
                        <svg viewBox="0 0 20 20" fill="none" class="section-icon">
                            <circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5" />
                            <path d="M10 7v3l2 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <span>Overview</span>
                        <svg viewBox="0 0 20 20" fill="none" class="chevron">
                            <path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </button>
                    <div class="nav-section-content" *ngIf="expandedSections['overview']">
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'introduction')"
                            [class.active]="activeSection === 'introduction'">Introduction</a>
                        <a class="nav-item" href="javascript:void(0)"
                            (click)="scrollToSection($event, 'authentication')"
                            [class.active]="activeSection === 'authentication'">Authentication</a>
                        <a class="nav-item" href="javascript:void(0)"
                            (click)="scrollToSection($event, 'signature-generation')"
                            [class.active]="activeSection === 'signature-generation'">Signature Generation</a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'postman-setup')"
                            [class.active]="activeSection === 'postman-setup'">Postman Setup</a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'python-sdk')"
                            [class.active]="activeSection === 'python-sdk'">Python SDK</a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'base-url')"
                            [class.active]="activeSection === 'base-url'">Base URL</a>
                        <a class="nav-item" href="javascript:void(0)"
                            (click)="scrollToSection($event, 'response-format')"
                            [class.active]="activeSection === 'response-format'">Response Format</a>
                    </div>
                </div>


                <div class="nav-section">
                    <button class="nav-section-header" (click)="toggleSection('memories')"
                        [class.expanded]="expandedSections['memories']">
                        <svg viewBox="0 0 20 20" fill="none" class="section-icon">
                            <rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M7 7h6M7 10h6M7 13h4" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                        <span>Memories</span>
                        <svg viewBox="0 0 20 20" fill="none" class="chevron">
                            <path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </button>
                    <div class="nav-section-content" *ngIf="expandedSections['memories']">
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'create-memory')"
                            [class.active]="activeSection === 'create-memory'">
                            <span class="method-badge post">POST</span>
                            Create Memory
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'memory-status')"
                            [class.active]="activeSection === 'memory-status'">
                            <span class="method-badge post">POST</span>
                            Memory Status
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'list-memories')"
                            [class.active]="activeSection === 'list-memories'">
                            <span class="method-badge post">POST</span>
                            List Memories
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'chat')"
                            [class.active]="activeSection === 'chat'">
                            <span class="method-badge post">POST</span>
                            Chat
                        </a>
                        <a class="nav-item" href="javascript:void(0)"
                            (click)="scrollToSection($event, 'summarize-memory')"
                            [class.active]="activeSection === 'summarize-memory'">
                            <span class="method-badge post">POST</span>
                            Summarize Memory
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'forget-memory')"
                            [class.active]="activeSection === 'forget-memory'">
                            <span class="method-badge post">POST</span>
                            Forget Memory
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'health')"
                            [class.active]="activeSection === 'health'">
                            <span class="method-badge post">POST</span>
                            Health Check
                        </a>
                    </div>
                </div>

                <div class="nav-section">
                    <button class="nav-section-header" (click)="toggleSection('tags')"
                        [class.expanded]="expandedSections['tags']">
                        <svg viewBox="0 0 20 20" fill="none" class="section-icon">
                            <path d="M3 6l7-3 7 3v5l-7 6-7-6V6z" stroke="currentColor" stroke-width="1.5"
                                stroke-linejoin="round" />
                        </svg>
                        <span>Tags</span>
                        <svg viewBox="0 0 20 20" fill="none" class="chevron">
                            <path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </button>
                    <div class="nav-section-content" *ngIf="expandedSections['tags']">
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'list-tags')"
                            [class.active]="activeSection === 'list-tags'">
                            <span class="method-badge post">POST</span>
                            List Tags
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'add-tag')"
                            [class.active]="activeSection === 'add-tag'">
                            <span class="method-badge post">POST</span>
                            Add Tag
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'get-by-tag')"
                            [class.active]="activeSection === 'get-by-tag'">
                            <span class="method-badge post">POST</span>
                            Get by Tag
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'change-tag')"
                            [class.active]="activeSection === 'change-tag'">
                            <span class="method-badge post">POST</span>
                            Change Tag
                        </a>
                    </div>
                </div>

                <div class="nav-section">
                    <button class="nav-section-header" (click)="toggleSection('skills')"
                        [class.expanded]="expandedSections['skills']">
                        <svg viewBox="0 0 20 20" fill="none" class="section-icon">
                            <path
                                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <span>Third Party Apps</span>
                        <svg viewBox="0 0 20 20" fill="none" class="chevron">
                            <path d="M6 8l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                    </button>
                    <div class="nav-section-content" *ngIf="expandedSections['skills']">
                        <a class="nav-item" href="javascript:void(0)"
                            (click)="scrollToSection($event, 'skills-overview')"
                            [class.active]="activeSection === 'skills-overview'">
                            Apps Overview
                        </a>
                        <a class="nav-item" href="javascript:void(0)" (click)="scrollToSection($event, 'openclaw')"
                            [class.active]="activeSection === 'openclaw'">
                            OpenClaw
                        </a>
                    </div>
                </div>
            </nav>
        </aside>

        <!-- Main Content -->
        <main class="docs-content">
            <!-- Hero Section -->
            <section class="docs-hero">
                <div class="hero-content">
                    <div class="hero-badge">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" stroke-width="1.5"
                                stroke-linejoin="round" />
                        </svg>
                        <span>LIAM Memory Management API</span>
                    </div>
                    <h1>Build with <span class="gradient-text">LIAM</span></h1>
                    <p class="hero-description">
                        The LIAM Memory Management API Suite provides a robust set of endpoints for efficiently managing
                        and monitoring memory resources. Designed for developers and system administrators, these APIs
                        enable precise control over memory allocation, utilization tracking, and cleanup processes.
                    </p>
                    <div class="hero-actions">
                        <a class="btn-primary" (click)="scrollToSection($event, 'register-connector')">
                            <span>Get Started</span>
                            <svg viewBox="0 0 20 20" fill="none">
                                <path d="M4 10h12M12 6l4 4-4 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </a>
                        <a class="btn-secondary" href="/assets/postman/postman_collection.json" download>
                            <svg viewBox="0 0 20 20" fill="none">
                                <path d="M10 3v10M6 9l4 4 4-4M4 15h12" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>Download Postman Collection</span>
                        </a>
                    </div>
                </div>
                <div class="hero-visual">
                    <div class="code-preview">
                        <div class="code-header">
                            <div class="dots">
                                <span></span><span></span><span></span>
                            </div>
                            <span class="file-name">Quick Start</span>
                        </div>
                        <pre class="code-block"><code><span class="comment">// Create a new memory</span>
<span class="keyword">const</span> response = <span class="keyword">await</span> fetch(<span class="string">'{{base_url}}/api/memory/create'</span>, &#123;
  <span class="property">method</span>: <span class="string">'POST'</span>,
  <span class="property">headers</span>: &#123;
    <span class="string">'Content-Type'</span>: <span class="string">'application/json'</span>,
    <span class="string">'apiKey'</span>: <span class="string">'YOUR_API_KEY'</span>,
    <span class="string">'signature'</span>: <span class="string">'YOUR_SIGNATURE'</span>
  &#125;,
  <span class="property">body</span>: JSON.stringify(&#123;
    <span class="property">userKey</span>: <span class="string">'user_key_here'</span>,
    <span class="property">content</span>: <span class="string">'Your memory content'</span>,
    <span class="property">tag</span>: <span class="string">'personal'</span>
  &#125;)
&#125;);</code></pre>
                    </div>
                </div>
            </section>

            <!-- Overview Sections -->
            <section id="introduction" class="docs-section">
                <div class="section-header">
                    <h2>Introduction</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        Welcome to the LIAM LIAM API documentation. This API allows you to integrate memory management
                        capabilities into your applications, enabling users to store, retrieve, and manage their
                        memories
                        seamlessly through various connectors including ChatGPT, Claude AI, Perplexity, and more.
                    </p>
                    <div class="feature-cards">
                        <div class="feature-card">
                            <div class="feature-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M2 17l10 5 10-5" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                    <path d="M2 12l10 5 10-5" stroke="currentColor" stroke-width="1.5"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <h3>RESTful Design</h3>
                            <p>Clean, predictable REST API endpoints with JSON request/response format</p>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="11" width="18" height="10" rx="2" stroke="currentColor"
                                        stroke-width="1.5" />
                                    <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" stroke-width="1.5" />
                                </svg>
                            </div>
                            <h3>Secure by Design</h3>
                            <p>ECDSA signature-based authentication ensures data integrity and security</p>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">
                                <svg viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
                                    <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" />
                                </svg>
                            </div>
                            <h3>Real-time Processing</h3>
                            <p>Fast response times with intelligent memory tokenization and retrieval</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="authentication" class="docs-section">
                <div class="section-header">
                    <h2>Authentication</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        The LIAM API uses a combination of API key and ECDSA signature for authentication.
                        All authenticated requests must include the following headers:
                    </p>
                    <div class="params-table">
                        <div class="param-row header">
                            <span>Header</span>
                            <span>Type</span>
                            <span>Description</span>
                        </div>
                        <div class="param-row">
                            <code>apiKey</code>
                            <span class="type">string</span>
                            <span>Your unique API key obtained during connector registration</span>
                        </div>
                        <div class="param-row">
                            <code>signature</code>
                            <span class="type">string</span>
                            <span>Base64-encoded ECDSA signature (DER format) of the request body</span>
                        </div>
                    </div>
                </div>
            </section>

            <section id="signature-generation" class="docs-section">
                <div class="section-header">
                    <h2>Signature Generation</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        The LIAM API requires all requests to be signed using ECDSA (Elliptic Curve Digital Signature
                        Algorithm)
                        with the P-256 curve and SHA-256 hashing. This ensures data integrity and authenticates your
                        requests.
                    </p>

                    <div class="callout info">
                        <svg viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5" />
                            <path d="M10 6v1M10 9v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <div>
                            <strong>Algorithm Details</strong>
                            <p>Algorithm: ECDSA | Curve: P-256 (secp256r1) | Hash: SHA-256 | Output: DER-encoded Base64
                            </p>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 1: Generate Key Pair (One-time setup)</h4>
                        <p>Generate an ECDSA key pair using the P-256 curve. Store the private key securely.</p>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JavaScript</span>
                                <span class="file-name">Key Generation</span>
                            </div>
                            <pre class="code-block"><code><span class="comment">// Generate ECDSA key pair</span>
<span class="keyword">async function</span> <span class="property">generateKeyPair</span>() &#123;
  <span class="keyword">const</span> keyPair = <span class="keyword">await</span> crypto.subtle.generateKey(
    &#123;
      <span class="property">name</span>: <span class="string">'ECDSA'</span>,
      <span class="property">namedCurve</span>: <span class="string">'P-256'</span>
    &#125;,
    <span class="keyword">true</span>,  <span class="comment">// extractable</span>
    [<span class="string">'sign'</span>, <span class="string">'verify'</span>]
  );
  <span class="keyword">return</span> keyPair;
&#125;

<span class="comment">// Export private key as PEM</span>
<span class="keyword">async function</span> <span class="property">exportPrivateKey</span>(privateKey) &#123;
  <span class="keyword">const</span> exported = <span class="keyword">await</span> crypto.subtle.exportKey(<span class="string">'pkcs8'</span>, privateKey);
  <span class="keyword">const</span> base64 = btoa(String.fromCharCode(...<span class="keyword">new</span> Uint8Array(exported)));
  <span class="keyword">return</span> <span class="string">`-----BEGIN PRIVATE KEY-----\n$&#123;base64&#125;\n-----END PRIVATE KEY-----`</span>;
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 2: Sign Request Body</h4>
                        <p>Sign the stringified JSON request body with your private key.</p>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JavaScript</span>
                                <span class="file-name">Signing Function</span>
                            </div>
                            <pre class="code-block"><code><span class="comment">// Sign data with ECDSA</span>
<span class="keyword">async function</span> <span class="property">signRequest</span>(privateKey, data) &#123;
  <span class="comment">// Convert data to string if object</span>
  <span class="keyword">const</span> dataString = <span class="keyword">typeof</span> data === <span class="string">'string'</span> 
    ? data 
    : JSON.stringify(data);
  
  <span class="comment">// Encode to bytes</span>
  <span class="keyword">const</span> encoder = <span class="keyword">new</span> TextEncoder();
  <span class="keyword">const</span> dataBytes = encoder.encode(dataString);
  
  <span class="comment">// Sign with ECDSA SHA-256</span>
  <span class="keyword">const</span> signature = <span class="keyword">await</span> crypto.subtle.sign(
    &#123;
      <span class="property">name</span>: <span class="string">'ECDSA'</span>,
      <span class="property">hash</span>: &#123; <span class="property">name</span>: <span class="string">'SHA-256'</span> &#125;
    &#125;,
    privateKey,
    dataBytes
  );
  
  <span class="comment">// Convert to DER format and Base64 encode</span>
  <span class="keyword">const</span> derSignature = toDER(<span class="keyword">new</span> Uint8Array(signature));
  <span class="keyword">return</span> derSignature;
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 3: Convert to DER Format</h4>
                        <p>The signature must be converted to DER (Distinguished Encoding Rules) format before Base64
                            encoding.</p>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JavaScript</span>
                                <span class="file-name">DER Encoding</span>
                            </div>
                            <pre class="code-block"><code><span class="comment">// Convert raw ECDSA signature to DER format</span>
<span class="keyword">function</span> <span class="property">toDER</span>(signature) &#123;
  <span class="comment">// Split signature into r and s components (32 bytes each for P-256)</span>
  <span class="keyword">let</span> r = Array.from(signature.slice(<span class="number">0</span>, <span class="number">32</span>));
  <span class="keyword">let</span> s = Array.from(signature.slice(<span class="number">32</span>));
  
  <span class="comment">// Add leading zero if high bit is set (to indicate positive number)</span>
  <span class="keyword">if</span> (r[<span class="number">0</span>] & <span class="number">0x80</span>) r = [<span class="number">0</span>].concat(r);
  <span class="keyword">if</span> (s[<span class="number">0</span>] & <span class="number">0x80</span>) s = [<span class="number">0</span>].concat(s);
  
  <span class="comment">// Remove leading zeros (except one if next byte has high bit)</span>
  r = removeLeadingZeros(r);
  s = removeLeadingZeros(s);
  
  <span class="comment">// Build DER structure: SEQUENCE &#123; INTEGER r, INTEGER s &#125;</span>
  <span class="keyword">let</span> arr = [<span class="number">0x02</span>];  <span class="comment">// INTEGER tag for r</span>
  constructLength(arr, r.length);
  arr = arr.concat(r);
  
  arr.push(<span class="number">0x02</span>);  <span class="comment">// INTEGER tag for s</span>
  constructLength(arr, s.length);
  arr = arr.concat(s);
  
  <span class="keyword">let</span> result = [<span class="number">0x30</span>];  <span class="comment">// SEQUENCE tag</span>
  constructLength(result, arr.length);
  result = result.concat(arr);
  
  <span class="comment">// Base64 encode</span>
  <span class="keyword">return</span> btoa(String.fromCharCode(...result));
&#125;

<span class="keyword">function</span> <span class="property">removeLeadingZeros</span>(arr) &#123;
  <span class="keyword">while</span> (arr.length > <span class="number">1</span> && arr[<span class="number">0</span>] === <span class="number">0</span> && !(arr[<span class="number">1</span>] & <span class="number">0x80</span>)) &#123;
    arr = arr.slice(<span class="number">1</span>);
  &#125;
  <span class="keyword">return</span> arr;
&#125;

<span class="keyword">function</span> <span class="property">constructLength</span>(arr, len) &#123;
  <span class="keyword">if</span> (len < <span class="number">0x80</span>) &#123;
    arr.push(len);
  &#125; <span class="keyword">else</span> &#123;
    <span class="keyword">const</span> octets = <span class="number">1</span> + (Math.log(len) / Math.LN2 >>> <span class="number">3</span>);
    arr.push(octets | <span class="number">0x80</span>);
    <span class="keyword">for</span> (<span class="keyword">let</span> i = octets - <span class="number">1</span>; i >= <span class="number">0</span>; i--) &#123;
      arr.push((len >>> (i * <span class="number">8</span>)) & <span class="number">0xff</span>);
    &#125;
  &#125;
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Complete Example: Making an Authenticated Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JavaScript</span>
                                <span class="file-name">Full Example</span>
                            </div>
                            <pre class="code-block"><code><span class="comment">// Complete authenticated API request</span>
<span class="keyword">async function</span> <span class="property">makeAuthenticatedRequest</span>(endpoint, payload, apiKey, privateKey) &#123;
  <span class="comment">// Sign the request body</span>
  <span class="keyword">const</span> signature = <span class="keyword">await</span> signRequest(privateKey, payload);
  
  <span class="comment">// Make the API request</span>
  <span class="keyword">const</span> response = <span class="keyword">await</span> fetch(<span class="string">`https://api.liam.netxd.com/api/$&#123;endpoint&#125;`</span>, &#123;
    <span class="property">method</span>: <span class="string">'POST'</span>,
    <span class="property">headers</span>: &#123;
      <span class="string">'Content-Type'</span>: <span class="string">'application/json'</span>,
      <span class="string">'apiKey'</span>: apiKey,
      <span class="string">'signature'</span>: signature
    &#125;,
    <span class="property">body</span>: JSON.stringify(payload)
  &#125;);
  
  <span class="keyword">return</span> response.json();
&#125;

<span class="comment">// Usage example</span>
<span class="keyword">const</span> payload = &#123;
  <span class="property">userKey</span>: <span class="string">'user_123'</span>,
  <span class="property">content</span>: <span class="string">'Remember that I prefer morning meetings'</span>,
  <span class="property">tag</span>: <span class="string">'preferences'</span>
&#125;;

<span class="keyword">const</span> result = <span class="keyword">await</span> makeAuthenticatedRequest(
  <span class="string">'memory/create'</span>,
  payload,
  <span class="string">'your-api-key'</span>,
  privateKey
);</code></pre>
                        </div>
                    </div>

                    <div class="callout warning">
                        <svg viewBox="0 0 20 20" fill="none">
                            <path d="M10 3L2 17h16L10 3z" stroke="currentColor" stroke-width="1.5"
                                stroke-linejoin="round" />
                            <path d="M10 8v4M10 14v1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <div>
                            <strong>Security Best Practices</strong>
                            <p>Never expose your private key in client-side code. Store it securely on your server and
                                perform signing operations server-side.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="postman-setup" class="docs-section">
                <div class="section-header">
                    <h2>Postman Setup</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        To test the LIAM API using Postman, you'll need to configure a pre-request script that
                        automatically
                        signs your requests. This script uses the jsrsasign library for ECDSA signature generation.
                    </p>

                    <div class="callout info" style="margin: 1.5rem 0;">
                        <svg viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px;">
                            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div>
                            <strong>Download Postman Collection</strong>
                            <p style="margin-bottom: 1rem;">Get the pre-configured Postman collection with all endpoints
                                and authentication already set up:</p>
                            <a href="https://github.com/netsys-usa/liam-agent/raw/master/liam-python-sdk/docs/liam-api.postman_collection.json"
                                target="_blank" class="btn-secondary"
                                style="display: inline-flex; align-items: center; gap: 0.5rem; color: #f97316; text-decoration: none;">
                                <svg viewBox="0 0 20 20" fill="none" style="width: 18px; height: 18px;">
                                    <path d="M10 3v10m0 0l-3-3m3 3l3-3M3 17h14" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Download Collection JSON
                            </a>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 1: Set Environment Variables</h4>
                        <p>Create the following environment variables in Postman:</p>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Variable</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>xdbc-privatekey</code>
                                <span class="type">string</span>
                                <span>Your PEM-formatted private key (with \n for newlines)</span>
                            </div>
                            <div class="param-row">
                                <code>xdbc-apikey</code>
                                <span class="type">string</span>
                                <span>Your API key from connector registration</span>
                            </div>
                        </div>

                        <div class="callout info">
                            <svg viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5" />
                                <path d="M10 6v1M10 9v5" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                            <div>
                                <strong>Private Key Format</strong>
                                <p>Store your private key with literal \n characters for newlines, e.g.:
                                    <code>-----BEGIN PRIVATE KEY-----\nMIGH...base64...\n-----END PRIVATE KEY-----</code>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 2: Add Pre-request Script</h4>
                        <p>Add this script to your Postman collection's pre-request scripts. It will automatically sign
                            every request:</p>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JavaScript</span>
                                <span class="file-name">Postman Pre-request Script</span>
                                <button class="copy-btn" (click)="copyToClipboard(postmanScript)">Copy</button>
                            </div>
                            <pre class="code-block"><code><span class="comment">// Load jsrsasign library (downloads once and caches)</span>
<span class="keyword">if</span> (globals[<span class="string">'jsrsasign-js'</span>] === <span class="keyword">undefined</span>) &#123;
    console.log(<span class="string">"Downloading jsrsasign library..."</span>);
    
    pm.sendRequest(&#123;
        <span class="property">url</span>: <span class="string">"http://kjur.github.io/jsrsasign/jsrsasign-latest-all-min.js"</span>,
        <span class="property">method</span>: <span class="string">"GET"</span>,
        <span class="property">body</span>: &#123;&#125;
    &#125;, <span class="keyword">function</span>(err, res) &#123;
        postman.setEnvironmentVariable(<span class="string">"jsrsasign-js"</span>, res.text());
        doHttpSig();
    &#125;);
&#125; <span class="keyword">else</span> &#123;
    doHttpSig();
&#125;

<span class="keyword">function</span> <span class="property">doHttpSig</span>() &#123;
    <span class="comment">// Create fake browser objects for the library</span>
    <span class="keyword">var</span> navigator = &#123;&#125;;
    <span class="keyword">var</span> window = &#123;&#125;;
    
    <span class="comment">// Load the jsrsasign library</span>
    eval(postman.getGlobalVariable(<span class="string">"jsrsasign-js"</span>));
    
    <span class="comment">// Get and format the private key</span>
    <span class="keyword">let</span> pk = postman.getEnvironmentVariable(<span class="string">"xdbc-privatekey"</span>);
    <span class="keyword">let</span> pks = pk.split(<span class="string">/\\n/</span>);
    <span class="keyword">let</span> privateKey = <span class="string">""</span>;
    <span class="keyword">for</span> (<span class="keyword">let</span> i = <span class="number">0</span>; i &lt; pks.length; i++) &#123;
        privateKey += pks[i] + <span class="string">"\n"</span>;
    &#125;
    
    <span class="comment">// Configure signature algorithm</span>
    <span class="keyword">var</span> signature_algo = <span class="string">"SHA256withECDSA"</span>;
    <span class="keyword">var</span> payload = request.data;
    
    <span class="comment">// Create and initialize signature</span>
    <span class="keyword">var</span> sig = <span class="keyword">new</span> KJUR.crypto.Signature(&#123;
        <span class="string">"alg"</span>: signature_algo
    &#125;);
    sig.init(privateKey);
    
    <span class="comment">// Format and sign the request body</span>
    <span class="keyword">var</span> reqBody = JSON.parse(payload);
    pm.request.body.raw = JSON.stringify(reqBody);
    <span class="keyword">var</span> payloadFmt = JSON.stringify(reqBody);
    sig.updateString(payloadFmt);
    
    <span class="comment">// Generate signature and convert to Base64</span>
    <span class="keyword">var</span> sigValueHex = sig.sign();
    <span class="keyword">var</span> sigBase64 = hextob64(sigValueHex);
    
    <span class="comment">// Add authentication headers</span>
    <span class="keyword">var</span> apiKey = postman.getEnvironmentVariable(<span class="string">"xdbc-apikey"</span>);
    pm.request.headers.add(&#123; <span class="property">key</span>: <span class="string">"apiKey"</span>, <span class="property">value</span>: apiKey &#125;);
    pm.request.headers.add(&#123; <span class="property">key</span>: <span class="string">"signature"</span>, <span class="property">value</span>: sigBase64 &#125;);
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Step 3: Test Your Setup</h4>
                        <p>Try a simple request to verify everything is working:</p>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">HTTP</span>
                                <span class="file-name">Test Request</span>
                            </div>
                            <pre class="code-block"><code><span class="keyword">POST</span> <span class="string">https://api.liam.netxd.com/api/memory/health</span>
<span class="property">Content-Type</span>: application/json

&#123;
  <span class="property">"ping"</span>: <span class="string">"test"</span>
&#125;</code></pre>
                        </div>
                        <p style="margin-top: 1rem;">If successful, you'll receive a response with status "Success". The
                            <code>apiKey</code> and <code>signature</code> headers are automatically added by the
                            pre-request script.
                        </p>
                    </div>

                    <div class="callout warning">
                        <svg viewBox="0 0 20 20" fill="none">
                            <path d="M10 3L2 17h16L10 3z" stroke="currentColor" stroke-width="1.5"
                                stroke-linejoin="round" />
                            <path d="M10 8v4M10 14v1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        <div>
                            <strong>Troubleshooting</strong>
                            <p>If you get signature errors, ensure your private key is properly formatted with \n
                                newlines and matches the public key registered with your connector.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="python-sdk" class="docs-section">
                <div class="section-header">
                    <h2>Python SDK</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        We provide an official Python SDK for integrating with the LIAM API. The SDK includes
                        synchronous and asynchronous clients, ECDSA key generation utilities, and comprehensive
                        examples.
                    </p>

                    <div class="callout info" style="margin-top: 1.5rem;">
                        <svg viewBox="0 0 20 20" fill="none">
                            <path d="M10 2L2 7l8 5 8-5-8-5z" stroke="currentColor" stroke-width="1.5"
                                stroke-linejoin="round" />
                            <path d="M2 12l8 5 8-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <div>
                            <strong>GitHub Repository</strong>
                            <p style="margin-bottom: 1rem;">Get the full Python SDK with examples, tests, and
                                documentation:</p>
                            <a href="https://github.com/netsys-usa/liam-agent/tree/master/liam-python-sdk"
                                target="_blank" class="btn-secondary"
                                style="display: inline-flex; align-items: center; gap: 0.5rem; color: #f97316; text-decoration: none;">
                                <svg viewBox="0 0 24 24" fill="currentColor" style="width: 20px; height: 20px;">
                                    <path
                                        d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
                                </svg>
                                github.com/netsys-usa/liam-agent
                            </a>
                        </div>
                    </div>

                    <div class="detail-section" style="margin-top: 2rem;">
                        <h4>Quick Start</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">Bash</span>
                                <span class="file-name">Installation</span>
                            </div>
                            <pre class="code-block"><code><span class="comment"># Clone the repository</span>
git clone https://github.com/netsys-usa/liam-agent.git
cd liam-agent/liam-python-sdk

<span class="comment"># Install the SDK</span>
pip install -e .

<span class="comment"># Or install dependencies directly</span>
pip install cryptography requests aiohttp</code></pre>
                        </div>
                    </div>

                    <div class="detail-section" style="margin-top: 1.5rem;">
                        <h4>Features</h4>
                        <ul style="color: #6b7280; margin-left: 1.5rem;">
                            <li>Synchronous and asynchronous API clients</li>
                            <li>ECDSA P-256 key generation and signing utilities</li>
                            <li>Full coverage of all LIAM API endpoints</li>
                            <li>Batch operations for high-throughput use cases</li>
                            <li>Comprehensive examples and documentation</li>
                            <li>Type hints and detailed docstrings</li>
                        </ul>
                    </div>

                    <div class="detail-section" style="margin-top: 2rem;">
                        <h4>Additional Resources</h4>
                        <div style="display: flex; flex-direction: column; gap: 1rem; margin-top: 1rem;">
                            <a href="https://github.com/netsys-usa/liam-agent/tree/master/liam-python-sdk/docs/postman"
                                target="_blank"
                                style="display: inline-flex; align-items: center; gap: 0.75rem; padding: 1rem; background: #f3f4f6; border-radius: 8px; text-decoration: none; color: #374151; transition: background 0.2s;">
                                <svg viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px; flex-shrink: 0;">
                                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="#f97316"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <div>
                                    <strong style="color: #111827;">Postman Collection</strong>
                                    <p style="margin: 0; font-size: 0.875rem; color: #6b7280;">Import ready-to-use API
                                        requests into Postman</p>
                                </div>
                            </a>
                            <a href="https://github.com/netsys-usa/liam-agent/tree/master/liam-python-sdk/docs/md"
                                target="_blank"
                                style="display: inline-flex; align-items: center; gap: 0.75rem; padding: 1rem; background: #f3f4f6; border-radius: 8px; text-decoration: none; color: #374151; transition: background 0.2s;">
                                <svg viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px; flex-shrink: 0;">
                                    <path
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                        stroke="#f97316" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <div>
                                    <strong style="color: #111827;">AI Agent Documentation</strong>
                                    <p style="margin: 0; font-size: 0.875rem; color: #6b7280;">Markdown reference for
                                        LLM/AI agent integration</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            <section id="base-url" class="docs-section">
                <div class="section-header">
                    <h2>Base URL</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <div class="base-url-box">
                        <span class="label">Production</span>
                        <code>https://api.liam.netxd.com</code>
                        <button class="copy-btn" (click)="copyToClipboard('https://api.liam.netxd.com')">
                            <svg viewBox="0 0 20 20" fill="none">
                                <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor"
                                    stroke-width="1.5" />
                                <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </section>

            <section id="response-format" class="docs-section">
                <div class="section-header">
                    <h2>Response Format</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>All API responses follow a consistent JSON structure:</p>
                    <div class="code-example">
                        <div class="code-header">
                            <span class="response-badge success">200 OK</span>
                            <span class="file-name">Success Response</span>
                        </div>
                        <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Success"</span>,
  <span class="property">"message"</span>: <span class="string">"Request processed successfully."</span>,
  <span class="property">"data"</span>: &#123; ... &#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T06:35:03.071785+00:00"</span>,
  <span class="property">"process_id"</span>: <span class="string">"72ce430e0a0c11f091b0e880883aad51"</span>
&#125;</code></pre>
                    </div>
                    <div class="code-example">
                        <div class="code-header">
                            <span class="response-badge error">400 Bad Request</span>
                            <span class="file-name">Error Response</span>
                        </div>
                        <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Failed"</span>,
  <span class="property">"message"</span>: <span class="string">"Invalid name"</span>,
  <span class="property">"details"</span>: &#123;
    <span class="property">"name"</span>: <span class="string">"Connector Name already exists"</span>
  &#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T06:35:29.916548+00:00"</span>,
  <span class="property">"process_id"</span>: <span class="string">"82d0ae4b0a0c11f09147e880883aad51"</span>
&#125;</code></pre>
                    </div>
                </div>
            </section>


            <!-- Memory Endpoints -->
            <div class="section-divider">
                <div class="divider-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.5" />
                        <path d="M8 8h8M8 12h8M8 16h5" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" />
                    </svg>
                </div>
                <h2>Memories</h2>
                <p>Endpoints for creating, retrieving, and managing memories</p>
            </div>

            <section id="create-memory" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/create</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/create')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Create Memory</h3>
                <p class="endpoint-desc">
                    Create a new memory entry for a user. Memories are automatically tokenized and indexed for
                    efficient retrieval.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>content</code>
                                <span class="type">string</span>
                                <span>The memory content to store <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>tag</code>
                                <span class="type">string</span>
                                <span>Optional tag for categorization</span>
                            </div>
                            <div class="param-row">
                                <code>sessionId</code>
                                <span class="type">string</span>
                                <span>Optional session identifier</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                                <button class="copy-btn" (click)="copyCode('memory-req')">Copy</button>
                            </div>
                            <pre class="code-block" id="memory-req"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>,
  <span class="property">"tag"</span>: <span class="string">"immigration"</span>,
  <span class="property">"content"</span>: <span class="string">"Need to visit office wed and friday for PR"</span>,
  <span class="property">"sessionId"</span>: <span class="string">"2025060400001"</span>
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Response</h4>
                        <div class="response-tabs">
                            <button class="tab-btn" [class.active]="activeTab['memory'] === 'success'"
                                (click)="setActiveTab('memory', 'success')">
                                <span class="status-dot success"></span>
                                200 Success
                            </button>
                            <button class="tab-btn" [class.active]="activeTab['memory'] === 'error'"
                                (click)="setActiveTab('memory', 'error')">
                                <span class="status-dot error"></span>
                                400 Error
                            </button>
                        </div>
                        <div class="code-example" *ngIf="activeTab['memory'] === 'success'">
                            <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Success"</span>,
  <span class="property">"message"</span>: <span class="string">"Your memory has been recorded successfully."</span>,
  <span class="property">"data"</span>: &#123;&#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T07:37:25.314532+00:00"</span>,
  <span class="property">"processId"</span>: <span class="string">"295492e00a1511f0a7eee880883aad51"</span>
&#125;</code></pre>
                        </div>
                        <div class="code-example" *ngIf="activeTab['memory'] === 'error'">
                            <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Failed"</span>,
  <span class="property">"message"</span>: <span class="string">"Profile not found."</span>,
  <span class="property">"details"</span>: &#123;
    <span class="property">"userKey"</span>: <span class="string">"Profile not found"</span>
  &#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T07:34:14.663734+00:00"</span>,
  <span class="property">"processId"</span>: <span class="string">"b7b0a5b20a1411f09f3ae880883aad51"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="memory-status" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/status</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/status')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Memory Status</h3>
                <p class="endpoint-desc">
                    Check the status of a memory processing operation. Useful for tracking bulk uploads or async
                    operations.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>processId</code>
                                <span class="type">string</span>
                                <span>The process ID to check status for</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>,
  <span class="property">"processId"</span>: <span class="string">"295492e00a1511f0a7eee880883aad51"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="list-memories" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/list</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/list')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">List Memories</h3>
                <p class="endpoint-desc">
                    Retrieve a list of memories for a user, optionally filtered by tokens or query.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>tokens</code>
                                <span class="type">array</span>
                                <span>Array of tokens to filter by</span>
                            </div>
                            <div class="param-row">
                                <code>query</code>
                                <span class="type">string</span>
                                <span>Search query string</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Response</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="response-badge success">200 OK</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Success"</span>,
  <span class="property">"message"</span>: <span class="string">"Request processed successfully."</span>,
  <span class="property">"data"</span>: &#123;
    <span class="property">"memories"</span>: [
      &#123;
        <span class="property">"memory"</span>: <span class="string">"See Northern Lights in Iceland"</span>,
        <span class="property">"language"</span>: <span class="keyword">null</span>,
        <span class="property">"transactionNumber"</span>: <span class="string">"XD17429746496666580248165:0"</span>,
        <span class="property">"date"</span>: <span class="string">"03/26/2025 13:07:30"</span>,
        <span class="property">"docId"</span>: <span class="keyword">null</span>,
        <span class="property">"fileID"</span>: <span class="keyword">null</span>,
        <span class="property">"notesKey"</span>: <span class="keyword">null</span>,
        <span class="property">"tokens"</span>: [<span class="string">"Northern Lights"</span>, <span class="string">"Iceland"</span>]
      &#125;
    ]
  &#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T07:41:42.584187+00:00"</span>,
  <span class="property">"processId"</span>: <span class="string">"c28825860a1511f0b82de880883aad51"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="chat" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/chat</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/chat')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Chat</h3>
                <p class="endpoint-desc">
                    Query memories using natural language. The system uses AI to find relevant memories and
                    generate contextual responses.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>query</code>
                                <span class="type">string</span>
                                <span>Natural language query <span class="required">required</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="summarize-memory" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/summarize-memory</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/summarize-memory')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Summarize Memory</h3>
                <p class="endpoint-desc">
                    Generate an AI-powered summary of a collection of memories.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>memories</code>
                                <span class="type">array</span>
                                <span>Array of memory objects to summarize <span class="required">required</span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="forget-memory" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/forget</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/forget')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Forget Memory</h3>
                <p class="endpoint-desc">
                    Delete or mark a memory as forgotten. This removes the memory from active retrieval while optionally
                    preserving audit history.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>memoryId</code>
                                <span class="type">string</span>
                                <span>The ID of the memory to forget <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>permanent</code>
                                <span class="type">boolean</span>
                                <span>Whether to permanently delete (default: false)</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>,
  <span class="property">"memoryId"</span>: <span class="string">"mem_12345abcde"</span>,
  <span class="property">"permanent"</span>: <span class="keyword">false</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Tags Section Divider -->
            <div class="section-divider">
                <div class="divider-icon">
                    <svg viewBox="0 0 24 24" fill="none">
                        <path d="M3 6l7-3 7 3v5l-7 6-7-6V6z" stroke="currentColor" stroke-width="1.5"
                            stroke-linejoin="round" />
                        <circle cx="10" cy="9" r="2" stroke="currentColor" stroke-width="1.5" />
                    </svg>
                </div>
                <h2>Tags</h2>
                <p>Endpoints for managing tags and categorizing memories</p>
            </div>

            <section id="list-tags" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/list-tags</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/list-tags')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">List Tags</h3>
                <p class="endpoint-desc">
                    Retrieve all tags associated with a user's memories. Returns a list of unique tags with memory
                    counts.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="add-tag" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/add-tag</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/add-tag')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Add Tag</h3>
                <p class="endpoint-desc">
                    Add a new tag to an existing memory. A memory can have multiple tags for flexible categorization.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>memoryId</code>
                                <span class="type">string</span>
                                <span>The ID of the memory <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>tag</code>
                                <span class="type">string</span>
                                <span>The tag to add <span class="required">required</span></span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>,
  <span class="property">"memoryId"</span>: <span class="string">"mem_12345abcde"</span>,
  <span class="property">"tag"</span>: <span class="string">"important"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="get-by-tag" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/get-by-tag</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/get-by-tag')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Get by Tag</h3>
                <p class="endpoint-desc">
                    Retrieve all memories that have a specific tag. Supports pagination for large result sets.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>tag</code>
                                <span class="type">string</span>
                                <span>The tag to filter by <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>limit</code>
                                <span class="type">number</span>
                                <span>Maximum number of results (default: 50)</span>
                            </div>
                            <div class="param-row">
                                <code>offset</code>
                                <span class="type">number</span>
                                <span>Number of results to skip for pagination</span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"f43d94a0935eb7eeb2323638b9d0af57c24975dc25c6e335e0d55b11025a9ebc"</span>,
  <span class="property">"tag"</span>: <span class="string">"immigration"</span>,
  <span class="property">"limit"</span>: <span class="number">20</span>,
  <span class="property">"offset"</span>: <span class="number">0</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="change-tag" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/change-tag</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/change-tag')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Change Tag</h3>
                <p class="endpoint-desc">
                    Update the tag associated with memories. This allows bulk re-categorization of memories.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Request Body</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Parameter</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>userKey</code>
                                <span class="type">string</span>
                                <span>The user's unique key <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>currentTag</code>
                                <span class="type">string</span>
                                <span>The current tag to change <span class="required">required</span></span>
                            </div>
                            <div class="param-row">
                                <code>updatedTag</code>
                                <span class="type">string</span>
                                <span>The new tag <span class="required">required</span></span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"userKey"</span>: <span class="string">"c0312641aade88080be0c7f0801bc4dc..."</span>,
  <span class="property">"currentTag"</span>: <span class="string">"things to do in 30s"</span>,
  <span class="property">"updatedTag"</span>: <span class="string">"30s wishlist"</span>
&#125;</code></pre>
                        </div>
                    </div>

                    <div class="detail-section">
                        <h4>Example Response</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="response-badge success">200 OK</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"status"</span>: <span class="string">"Success"</span>,
  <span class="property">"message"</span>: <span class="string">"Request processed successfully."</span>,
  <span class="property">"data"</span>: &#123;
    <span class="property">"profileId"</span>: <span class="number">20</span>,
    <span class="property">"status"</span>: <span class="string">"SUCCESS"</span>,
    <span class="property">"updatedCount"</span>: <span class="number">3</span>
  &#125;,
  <span class="property">"timestamp"</span>: <span class="string">"2025-03-26T20:00:11.010976+00:00"</span>,
  <span class="property">"processId"</span>: <span class="string">"ec72366a0a7c11f09a11e880883aad51"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <section id="health" class="docs-section endpoint-section">
                <div class="endpoint-header">
                    <span class="method-badge post large">POST</span>
                    <code class="endpoint-path">/api/memory/health</code>
                    <button class="copy-btn" (click)="copyToClipboard('/api/memory/health')">
                        <svg viewBox="0 0 20 20" fill="none">
                            <rect x="6" y="6" width="10" height="10" rx="2" stroke="currentColor" stroke-width="1.5" />
                            <path d="M4 14V5a1 1 0 011-1h9" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <h3 class="endpoint-title">Health Check</h3>
                <p class="endpoint-desc">
                    Check the health status of the memory API service.
                </p>

                <div class="endpoint-details">
                    <div class="detail-section">
                        <h4>Example Request</h4>
                        <div class="code-example">
                            <div class="code-header">
                                <span class="lang-badge">JSON</span>
                            </div>
                            <pre class="code-block"><code>&#123;
  <span class="property">"ping"</span>: <span class="string">"test"</span>
&#125;</code></pre>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Skills Section -->
            <section id="skills-overview" class="docs-section">
                <div class="section-header">
                    <h2>Third Party App Support</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        LIAM Skills are modular, reusable components that extend agent capabilities. Skills provide
                        pre-built functionality for common tasks, allowing AI agents to interact with external services,
                        process data, and perform complex operations.
                    </p>

                    <div class="callout info" style="margin-top: 1.5rem;">
                        <svg viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px;">
                            <path
                                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div>
                            <strong>Repository</strong>
                            <p style="margin-bottom: 1rem;">Browse all available skills and learn how to create your
                                own:</p>
                            <a href="https://github.com/netsys-usa/liam-agent/tree/master/skills" target="_blank"
                                class="btn-secondary"
                                style="display: inline-flex; align-items: center; gap: 0.5rem; color: #f97316; text-decoration: none;">
                                <svg viewBox="0 0 24 24" fill="currentColor" style="width: 20px; height: 20px;">
                                    <path
                                        d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
                                </svg>
                                github.com/netsys-usa/liam-agent/skills
                            </a>
                        </div>
                    </div>

                    <div class="detail-section" style="margin-top: 2rem;">
                        <h4>Available Skills</h4>
                        <div class="params-table">
                            <div class="param-row header">
                                <span>Skill</span>
                                <span>Type</span>
                                <span>Description</span>
                            </div>
                            <div class="param-row">
                                <code>OpenClaw</code>
                                <span class="type">Skill</span>
                                <span>xd-memory skill for OpenClaw with persistent cloud memory</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="openclaw" class="docs-section">
                <div class="section-header">
                    <h2>OpenClaw</h2>
                    <div class="section-line"></div>
                </div>
                <div class="section-content">
                    <p>
                        OpenClaw is an AI coding agent that runs in your terminal. The xd-memory skill gives OpenClaw
                        persistent, searchable cloud memory powered by LIAM. Once installed, the agent stores and
                        retrieves memories automatically.
                    </p>

                    <div class="callout info" style="margin-top: 1.5rem;">
                        <svg viewBox="0 0 24 24" fill="none" style="width: 24px; height: 24px;">
                            <path
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div>
                            <strong>Installation Guide</strong>
                            <p style="margin-bottom: 1rem;">Complete setup instructions for xd-memory skill:</p>
                            <a href="https://github.com/netsys-usa/liam-agent/blob/master/skills/openclaw/OPENCLAW.md"
                                target="_blank" class="btn-secondary"
                                style="display: inline-flex; align-items: center; gap: 0.5rem; color: #f97316; text-decoration: none;">
                                <svg viewBox="0 0 24 24" fill="currentColor" style="width: 20px; height: 20px;">
                                    <path
                                        d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />
                                </svg>
                                View Installation Guide
                            </a>
                        </div>
                    </div>

                    <div class="detail-section" style="margin-top: 2rem;">
                        <h4>Features</h4>
                        <ul style="color: #6b7280; margin-left: 1.5rem;">
                            <li>Persistent, searchable cloud memory for OpenClaw</li>
                            <li>Automatic memory storage and retrieval</li>
                            <li>Works on local Mac or Linux cloud VM</li>
                            <li>Uses mcporter for secure authentication</li>
                        </ul>
                    </div>
                </div>
            </section>

            <!-- Footer -->
            <footer class="docs-footer">
                <div class="footer-content">
                    <div class="footer-brand">
                        <svg width="32" height="32" viewBox="0 0 80 80" fill="none">
                            <rect width="80" height="80" rx="18" fill="#f97316" />
                            <path d="M25 18V62H55" stroke="white" stroke-width="6" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="25" cy="18" r="5" fill="white" />
                            <circle cx="55" cy="62" r="5" fill="white" />
                        </svg>
                        <span>LIAM API</span>
                    </div>
                    <p>Need help? Visit <a [href]="links.support" target="_blank" rel="noopener noreferrer">Support</a></p>
                    <p class="copyright">© 2025 NetXD. All rights reserved.</p>
                </div>
            </footer>
        </main>
    </div>
</div>